import { render, staticRenderFns } from "./form-quick-table.vue?vue&type=template&id=49d8dae6&scoped=true"
import script from "./form-quick-table.ts?vue&type=script&lang=ts&external"
export * from "./form-quick-table.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8dae6",
  null
  
)

export default component.exports